export var MuiTouchRipple = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        backgroundColor: theme.palette.primary.light
      };
    }
  }
};
//# sourceMappingURL=MuiTouchRipple.js.map